export type Test = "d" | "b" | "j" | "w" | "dv" | "dm";
export const Tests: Array<{ value: Test; text: string }> = [
  { value: "d", text: "Small Disturbed Sample (D)" },
  { value: "b", text: "Bulk Disturbed Sample (B)" },
  { value: "j", text: "Jar Sample (J)" },
  { value: "w", text: "Water Sample (W)" },
  { value: "dv", text: "Pilcon Vane kPa (DV)" },
  { value: "dm", text: "Mackintosh Probe (DM)" }
];
